<template>
  <div>
    <template v-if="isTags">
      <Tooltip placement="left" transfer>
        <div class="tag">
          <div class="content">{{ tag | getFirstTag }}</div>
          <Icon type="ios-eye" />
        </div>

        <div slot="content">
          <div v-html="$util.listTag(tag)"></div>
        </div>
      </Tooltip>
    </template>
    <template v-else>
      <div>
        {{ tag }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "TagList",
  props: ["tag"],
  computed: {
    isTags() {
      // if(tag.split(";").length > 0){

      // }
      if (typeof this.tag === "string") {
        if (this.tag.includes(";")) {
          return this.tag.split(";").length > 0;
        } else {
          if (this.tag.includes(",")) {
            return this.tag.split(",").length > 0;
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-tooltip-inner {
  white-space: normal;
  word-break: keep-all;
}
.tag {
  display: flex;
  align-items: center;
  width: 100%;
  // width: calc(100% - 14px);
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  .content {
    width: calc(100% - 20px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tagList.vue